import { useState } from 'react';
import { Colors } from '../../../../../../themes/colors';
import CustomPortal from '../../../../../commonComponents/CustomPortal';
import { InputSelect } from '../../../../../commonComponents/InputSelect/InputSelect';

export const ConfirmHireJobPopup = ({ onConfirm, onClose, candidates = [] }) => {
  const [selectedCandidate, setSelectedCandidate] = useState(null);

  const handleConfirm = () => {
    if (selectedCandidate) {
      onConfirm(selectedCandidate);
    }
  };

  const candidateOptions = candidates.map((candidate) => ({
    value: candidate.id,
    title: candidate.professionalName,
  }));

  return (
    <CustomPortal
      title="Who Was Hired?"
      containerStyle={{ paddingInline: 50, paddingTop: 30 }}
      textStyle={{ textAlign: 'center' }}
      cancelText="Go Back"
      submitText="Confirm"
      submitPressed={handleConfirm}
      cancelPressed={onClose}
      submitDisabled={!selectedCandidate}
    >
      <p
        style={{
          color: Colors.neutral_500,
          fontSize: 16,
          textAlign: 'center',
        }}
      >
        From the dropdown below, choose the GoTu candidate who was hired.
      </p>
      <p
        style={{
          marginTop: 10,
          fontSize: 16,
          color: Colors.neutral_600,
          fontWeight: 700,
          alignSelf: 'flex-start',
        }}
      >
        Candidates Name:
      </p>
      <InputSelect
        value={selectedCandidate}
        setValue={(value) => setSelectedCandidate(value)}
        options={candidateOptions}
        placeholder="Select candidate's name"
      />
      <div style={{ height: 20 }} />
    </CustomPortal>
  );
};
